export interface ProductionPlanSaveUiState {
  justSaved: boolean;
  planConflict: boolean;
}

/**
 * A local durable enqueue is only a provisional success. If the background
 * dispatcher later receives a terminal server rejection, revoke the saved
 * state immediately while the page remains mounted.
 */
export function productionPlanSaveUiAfterConflictRefresh(
  justSaved: boolean,
  hasConflict: boolean,
): ProductionPlanSaveUiState {
  return {
    justSaved: hasConflict ? false : justSaved,
    planConflict: hasConflict,
  };
}
